import { render, staticRenderFns } from "./RegistrarMovimientoDialogComponent.vue?vue&type=template&id=66cd8eb1"
import script from "./RegistrarMovimientoDialogComponent.vue?vue&type=script&lang=js"
export * from "./RegistrarMovimientoDialogComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports